/**
 * Flow Variable Validation Utilities
 *
 * Extracts {{variable_name}} placeholders from text and validates
 * them against the centralized flow variable registry.
 */

/**
 * Extract all variable names used in text as {{name}}.
 * @param {string} text
 * @returns {string[]} Array of unique variable names found
 */
export function getVariableNamesFromText(text) {
  if (!text) return [];
  const matches = text.match(/\{\{(\w+)\}\}/g);
  if (!matches) return [];
  const names = matches.map((m) => m.replace(/\{\{|\}\}/g, ""));
  return [...new Set(names)];
}

/**
 * Return variable names in the text that are NOT in the flow variable registry.
 * @param {string} text
 * @param {Array<{ name: string }>} flowVariables
 * @returns {string[]} Array of unknown variable names
 */
export function getUnknownVariableNames(text, flowVariables) {
  const usedNames = getVariableNamesFromText(text);
  if (usedNames.length === 0) return [];
  const knownNames = new Set((flowVariables || []).map((v) => v.name));
  return usedNames.filter((name) => !knownNames.has(name));
}
